import React from "react";
import QuotationAdd from "Containers/Quotation/QuotationAdd";
import QuotationPreview from "Containers/Quotation/QuotationPreview";
import QuotationPlanList from "Containers/Quotation/QuotationPlanList";
import QuotationPlanAdd from "Containers/Quotation/QuotationPlanAdd";
import QuotationList from "Containers/Quotation/QuotationList";

const Actions = {
  quotation_plan: {
    view: {
      codenames: [],
      action_code: "visible_quotation_plan_view",
      is_superuser_action: false,
      name: "View Quotation Plan",
      label: "Quotation Plan",
      action: "sub-menu",
      url: "/quotation/plan/list",
      component: <QuotationPlanList />,
      permission_needed: true,
      associated_urls: ["/quotation/plan"],
    },
    create: {
      codenames: [],
      action_code: "visible_quotation_plan_add",
      is_superuser_action: false,
      name: "Create Quotation Plan",
      label: "Quotation Plan",
      action: "action-url",
      url: "/quotation/plan",
      component: <QuotationPlanAdd />,
      permission_needed: true,
    },
    update: {
      codenames: [],
      action_code: "visible_quotation_plan_change",
      is_superuser_action: false,
      name: "Update Quotation Plan",
      label: "Quotation Plan",
      action: "action",
      permission_needed: true,
    },
    delete: {
      codenames: [],
      action_code: "visible_quotation_plan_delete",
      is_superuser_action: false,
      name: "Delete Quotation Plan",
      label: "Quotation Plan",
      action: "action",
      permission_needed: true,
    },
    name: "Quotation Plan",
    type: "Basic Details",
  },
  quotation: {
    view: {
      codenames: [],
      action_code: "visible_quotation_view",
      is_superuser_action: false,
      name: "View Quotation",
      label: "Quotation List",
      action: "sub-menu",
      url: "/quotation/list",
      component: <QuotationList />,
      permission_needed: true,
      associated_urls: ["/quotation/preview"],
    },
    create: {
      codenames: [],
      action_code: "visible_quotation_add",
      is_superuser_action: false,
      name: "Generate Quotation",
      label: "Quotation",
      action: "action-url",
      url: "/quotation/add",
      component: <QuotationAdd />,
      permission_needed: true,
    },
    name: "Quotation List",
    type: "Basic Details",
  },
};

export default Actions;

